import { RESOURCE_TYPE_OPTIONS } from '@/components/SyllabusTeachingLearningSupport'
import { TaxoResourceType } from '@/kontent/taxonomies'
import { mapTreeElementToTreeNode } from '@/layouts/wp_dc_recentchanges'
import { useMemo } from 'react'
import { TreeNodeProps } from 'react-dropdown-tree-select'

export const useResourceTypeTreeNodeProps = ({
	selectedResourceTypes,
	excludeResourceTypes = [],
	isUseResourceTypeName = false,
	additionalResourceTypeOptions = [],
	putOtherAtTheEnd = false,
	isSortByLabel = false,
}: {
	selectedResourceTypes: TaxoResourceType[]
	excludeResourceTypes?: TaxoResourceType[]

	isUseResourceTypeName?: boolean
	additionalResourceTypeOptions?: {
		name: string
		value: TaxoResourceType
	}[]
	putOtherAtTheEnd?: boolean
	isSortByLabel?: boolean
}) =>
	useMemo<TreeNodeProps[]>(() => {
		return [
			...additionalResourceTypeOptions.map<TreeNodeProps>((option) => {
				return {
					value: option.value,
					label: option.name,
					checked: selectedResourceTypes.includes(option.value),
				}
			}),
			...RESOURCE_TYPE_OPTIONS.map<TreeNodeProps>((option) => {
				const treeElement = {
					id: isUseResourceTypeName ? option.text : option.value,
					label: option.text,
					children: [],
				}
				return mapTreeElementToTreeNode(
					treeElement,
					selectedResourceTypes,
				)
			}),
		]
			.filter((option) => {
				return (
					!excludeResourceTypes.includes(
						option.value as TaxoResourceType,
					) &&
					// TODO: temporarily exclude syllabus_core_content. Remove below code when syllabus_core_content is published
					option.label !== 'Syllabus Core Content' &&
					(option.value as TaxoResourceType) !==
						'syllabus_core_content'
				)
			})
			.sort((a, b) => {
				if (putOtherAtTheEnd) {
					// if a.label is Other or b.label is Other, always put Other at the end
					if (a.label === 'Other' || b.label === 'Other') {
						return 1
					}
					if (isSortByLabel) {
						return a.label.localeCompare(b.label)
					}
				}
				if (isSortByLabel) {
					return a.label.localeCompare(b.label)
				}
				return 0
			})
	}, [excludeResourceTypes, selectedResourceTypes])
